module.exports = __webpack_public_path__ + "static/media/x.7c0a6d63.svg";